export default class ZendeskJWTHttpResponseDTO {
  constructor(options = {}) {
    this.validate(options)
    this.jwt = options.jwt
  }

  validate(options) {
    if (!options.jwt) {
      throw new Error('jwt is a required field')
    }
  }
}
